import { PatternFormat } from "react-number-format";

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

export const PhoneNumberFormat = (props: CustomProps) => {
  const { onChange, ...other } = props;

  return (
    <PatternFormat
      {...other}
      format='+7 ###-###-##-##'
      mask='_'
      allowEmptyFormatting
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
    />
  );
};
